export const getAppliesEnum = (state) => state.applies
export const getDiscountTypes = (state) => state.discountTypes
export const getPromotions = (state) => state.promotions
export const getCurrentPromotion = (state) => state.currentPromotion
export const getPendingProducts = (state) => state.pendingProducts
